import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { STETHDepositHelper__factory } from "../codegen";
import { STETHDepositHelperAddress, EarnSTETHDepositHelperAddress, } from "../constants/constants";
export var getSTETHDepositHelper = function (vaultVersion, library) {
    var depositHelperAddress = vaultVersion === "earn"
        ? EarnSTETHDepositHelperAddress
        : STETHDepositHelperAddress;
    if (library) {
        var provider = library.getSigner();
        return STETHDepositHelper__factory.connect(depositHelperAddress, provider);
    }
    return undefined;
};
var useSTETHDepositHelper = function (vaultVersion) {
    var _a = useWeb3React(), library = _a.library, active = _a.active;
    var _b = useState(), depositHelper = _b[0], setDepositHelper = _b[1];
    useEffect(function () {
        var helper = getSTETHDepositHelper(vaultVersion, library);
        setDepositHelper(helper);
    }, [active, library, vaultVersion]);
    return depositHelper;
};
export default useSTETHDepositHelper;
//# sourceMappingURL=useSTETHDepositHelper.js.map